import { atom } from 'jotai';

import type { Filter } from '../../Entities/Search/SearchFilters/Filter.entity';

const filtersListAtom = atom<Filter[]>([]);

export { filtersListAtom };
